import Header from './modules/header';
import './common/list/hashtag-list';
import './common/list/article-list';
import More from './modules/more';
import Accordion from './modules/accordion';
import Diagnosis from './modules/diagnosis';
import './modules/diagnosis2';
import Audio from './modules/audio';
import ArticleRelated from './modules/article-related';
import RadioSetting from './modules/radio';
import Anchor from './modules/anchor';
import Sns from './modules/sns';
import ReadTime from './modules/read-time';
import Fade from './modules/fade';
import ScrollTxt from './modules/scroll-txt';
import './modules/profile2-more';
import './modules/tabs';

window.addEventListener('DOMContentLoaded', () => {
  new Header();
  new More();
  new Accordion();
  new Diagnosis();
  new Audio();
  new RadioSetting();
  new Anchor();
  new Sns();
  new ReadTime();
  new Fade();
  new ScrollTxt();
});
